import React, { useEffect, useState } from 'react';
import { Chrome } from '@styled-icons/feather';
import { Button } from '@typedream/ui';
import Popup from '../../sharedComponents/TextEditor/components/Popup';

import {
  CHROME_WARNING_POPUP_HIDE_STORAGE_KEY,
  CHROME_WARNING_POPUP_HIDE_EXPIRY_DAYS,
} from '../../constants';
import isGoogleChromeDesktop from '../../utils/isGoogleChromeDesktop';

function ChromePopup() {
  const [open, setOpenLocal] = useState(false);
  useEffect(() => {
    if (
      localStorage &&
      (localStorage.getItem(CHROME_WARNING_POPUP_HIDE_STORAGE_KEY) === null ||
        Number(localStorage.getItem(CHROME_WARNING_POPUP_HIDE_STORAGE_KEY)) < Date.now())
    ) {
      setOpenLocal(!isGoogleChromeDesktop());
      if (Number(localStorage.getItem(CHROME_WARNING_POPUP_HIDE_STORAGE_KEY)) < Date.now()) {
        localStorage.removeItem(CHROME_WARNING_POPUP_HIDE_STORAGE_KEY);
      }
    }
  }, []);

  const setopen = (o: boolean) => {
    if (!o) {
      const addDaysTimestamp = CHROME_WARNING_POPUP_HIDE_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
      const expiryTimestamp = Date.now() + addDaysTimestamp;
      localStorage.setItem(CHROME_WARNING_POPUP_HIDE_STORAGE_KEY, String(expiryTimestamp));
    }
    setOpenLocal(o);
  };

  return (
    <Popup width={600} height={350} open={open} setopen={setopen} className="p-6">
      <Chrome size={40} className="with-lighter-text-color mb-5" />
      <div className="is-size-6 with-text-color mb-5">
        We recommend using Typedream on Google Chrome Desktop
      </div>
      <div className="is-subtitle with-light-text-color mb-5">
        We&apos;re working hard to create a seamless editing experience across all browsers. However
        for now, Typedream works the best on Google Chrome Desktop
      </div>
      <div className="is-flex is-align-items-center">
        <Button
          onClick={() => {
            window.location.href = 'https://www.google.com/chrome/';
          }}
        >
          Switch to Chrome
        </Button>
        <div
          className="is-subtitle with-cursor-pointer p-3 ml-2"
          onClick={() => setopen(false)}
          role="none"
        >
          Remind me again
        </div>
      </div>
    </Popup>
  );
}

export default React.memo(ChromePopup);
